import React, { useState } from 'react';
import {
  Checkbox,
  Select,
  MenuItem,
  FormHelperText,
  FormControl,
} from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import ButtonBase from '../../Buttons/ButtonBase';
import { HOURS } from '../../../utils/ConstantsMain';
import ComboText from '../../ComboText';
import { makeStyles } from '@material-ui/core/styles';
import SelectHour from '../../Profile/Schedule/SelectHour';
import { isMobile } from 'react-device-detect';
import AuthButton from '../../Buttons/AuthButton';
import SecondaryButton from '../../Buttons/SecondaryButton';
import ScheduleDivided from '../../Profile/Schedule/ScheduleDivided';
import { connect } from 'react-redux';

const useStyles = makeStyles(() => ({
  formControl: {
    margin: '8px 14px',
    marginBottom: 0,
    display: 'flex',
    flexFlow: 'row',
    maxWidth: '100%',
  },
}));

const weekDays = [
  'Lunes',
  'Martes',
  'Miércoles',
  'Jueves',
  'Viernes',
  'Sábado',
  'Domingo',
];

const ScheduleContinuous = ({
  values,
  typeSchedule,
  handleSubmit,
  touched,
  errors,
  handleBlur,
  setFieldValue,
  handleChange,
  isValid,
  resetForm,
  props,
  handleCancel,
  flagEdit,
  membershipType,
}) => {
  const classes = useStyles();
  const [hours, setHours] = useState([]);
  const [workDays, setWorkDays] = useState(values);

  const handleCheckBox = (field) => (event) => {
    let value = { ...values[event.target.value] };
    value = {
      ...value,
      open: !value.open,
    };

    setFieldValue(field, value);
  };

  /* const handleCheckBox = (event) => {
    let newWorkDays = {...workDays};
    newWorkDays[event.target.id] = {
      ...newWorkDays[event.target.id],
      open: !newWorkDays[event.target.id].open,
    };
    setWorkDays(newWorkDays);
    console.log(event.target.id);
  }; */

  const handleSelectHour = (weekDay, hours) => {
    /* let newWorkDays = [...workDays];
    newWorkDays[weekDay] = {
      ...newWorkDays[weekDay],
      start: hours.start,
      end: hours.end,
    }; */
    //setWorkDays(newWorkDays);
    let value = { ...values[weekDay] };
    value = {
      ...value,
      start: hours.start,
      end: hours.end,
    };
    setFieldValue(weekDay, value);
  };

  return (
    <>
      <form>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span
            style={{
              fontSize: 14,
              fontWeight: 'bold',
              margin: isMobile ? '0 24px 0 81px' : '0 24px 0 126px',
              color: '#484848'
            }}
          >
            Horario apertura
          </span>
          <span
            style={{
              fontSize: 14,
              fontWeight: 'bold',
              color: '#484848'
            }}
          >
            Horario cierre
          </span>
        </div>

        {weekDays.map((day, index) => (
          <div key={index} style={{ display: 'flex' }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                width: isMobile ? 70 : 116,
              }}
            >
              <Checkbox
                name={day}
                id={day}
                //checked={workDays[index].open}
                checked={values[day].open}
                onChange={handleCheckBox(day)}
                value={day}
                color="secondary"
              />

              <span
                style={{
                  color: '#484848',
                }}
              >
                {isMobile ? day.substring(0, 2) : day}
              </span>
            </div>
            <div>
              {values[day].open ? (
                <SelectHour
                  weekDay={day}
                  indexDay={index}
                  handleSelectHour={handleSelectHour}
                  start={values[day].start}
                  end={values[day].end}
                />
              ) : (
                <div
                  style={{
                    width: 244,
                    height: 48,
                    backgroundColor: '#f5f5f5',
                    color: '#969696',
                    display: 'flex',
                    margin: '8px 10px 10px',
                  }}
                >
                  <span style={{ margin: 'auto' }}>Cerrado</span>
                </div>
              )}
            </div>
          </div>
        ))}

        <div style={{ display: 'flex', marginTop: 18, width: '100%' }}>
          <ButtonBase
            type="submit"
            onClick={handleSubmit}
            variant="primary"
            style={{ marginRight: 24, minWidth: isMobile ? 144 : 160, padding: isMobile ? '0 7px' : 'inherit' }}
          >
            Guardar cambios
          </ButtonBase>
          <SecondaryButton
            variant={"enable"}
            onClick={(e)=> {
              handleCancel(e);
              !flagEdit && resetForm();
            }}
            style={{ width: isMobile ? 144 : 160, display: flagEdit || isValid? 'initial': 'none' }}
          >
            Cancelar
          </SecondaryButton>
        </div>
      </form>
    </>
  );
};

const mapStateToProps = (state) => ({
  membershipType: state.authClient.membership.type
});

export default connect(mapStateToProps)(ScheduleContinuous);
